import { render, staticRenderFns } from "./multiwarehouses.vue?vue&type=template&id=5d82a021&scoped=true&"
import script from "./multiwarehouses.vue?vue&type=script&lang=js&"
export * from "./multiwarehouses.vue?vue&type=script&lang=js&"
import style0 from "./multiwarehouses.vue?vue&type=style&index=0&id=5d82a021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82a021",
  null
  
)

export default component.exports